import { Bookmaker, BookmakerName, EarlyFeedFilterDateTimezone, EarlyFeedStartNextDayHour, IbcbetAllowedLimitsCategoryIds, SbobetAllowedCustomLeagueIds } from '@/constants';
import { toZonedTime } from 'date-fns-tz';

export function listSiteDataTooltip(datas: any[], clId: number, clLCId: number) {
    let qtipArray = [];
    let ibcProviderIndex, sboProviderIndex;
    let idx = 0;

    for (let key in datas) {
        const siteId = datas[key][0];
        if (siteId === Bookmaker.Betfair || siteId === Bookmaker.Pinweb) {
            continue;
        }

        let bookmakerName;
        if (siteId === Bookmaker.Sbo && !SbobetAllowedCustomLeagueIds.includes(clId)) {
            bookmakerName = 'Data Provider 3';
            sboProviderIndex = idx;
        } else if (siteId === Bookmaker.Ibc && !IbcbetAllowedLimitsCategoryIds.includes(clLCId)) {
            bookmakerName = 'Data Provider 2';
            ibcProviderIndex = idx;
        } else {
            bookmakerName = BookmakerName[siteId];
        }
        const width = 100;

        qtipArray.push(`<span style="width: ${width}px; display: inline-block;">${bookmakerName}</span> ${datas[key][1]}<br>`);
        idx++;
    }

    if (ibcProviderIndex !== undefined) {
        //no need to change indexes in array
        const moved = qtipArray[ibcProviderIndex];
        qtipArray[ibcProviderIndex] = null;
        qtipArray.push(moved);
    }

    if (sboProviderIndex !== undefined) {
        //no need to change indexes in array
        const moved = qtipArray[sboProviderIndex];
        qtipArray[sboProviderIndex] = null;
        qtipArray.push(moved);
    }

    return qtipArray.join('');
}

export function mergeFeedCustomEventIds(customEventId: string | null, betCustomEventIds: string[] | null): (string | null)[] {
    const ids = [customEventId, ...(betCustomEventIds ?? [])];

    return Array.from(new Set(ids.filter(Boolean))).sort();
}

export function getMinDateForEarlyFeed() {
    let londonDate = toZonedTime(new Date(), EarlyFeedFilterDateTimezone);

    if (londonDate.getHours() >= EarlyFeedStartNextDayHour) {
        londonDate.setDate(londonDate.getDate() + 1);
    }

    londonDate.setHours(0, 0, 0, 0);

    return londonDate;

    //return fromZonedTime(londonDate, timeZone);
}
